import removeLastCharacterStringUtil from 'utils/string/remove-last-character'

/**
 * @param str
 * @returns {string}
 */
const removeTrailingPeriodStringUtil = (str) => {
  str = str || ''

  if (str && str.endsWith('.')) {
    return removeLastCharacterStringUtil(str)
  }

  return str
}

export default removeTrailingPeriodStringUtil
